import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import { Formik, Field, Form } from "formik";

// import Select from "react-select";
// import CustomSelectInput from "../../../../../../components/common/CustomSelectInput";
import IntlMessages from "../../../../../../helpers/IntlMessages";

import { ProductPricing, Product } from "../../../../../../api/Api";

export default class AddConstant extends Component {
  state = {
    loading: false,
    file: "",
    initialValues: {
      name: "",
      areaCode: "",
      latitude: "",
      longitude: "",
      zoneTypeId: "",
      parentId: "",
    },
  };

  componentDidMount() {
    this.getProduct();
  }

  getProduct = async () => {
    const { data } = await Product.getAllProduct();
    this.setState({
      zoneType: data.data,
      zoneTypeId: data.data && data.data[0] && data.data[0].id,
    });
  };

  handleSubmit = async (values, { resetForm, setSubmitting, setValues }) => {
    this.setState({ loading: true });
    // console.log(this.props);
    try {
      let newValues = {
        ...values,
        parentId:
          this.props.dataItem && this.props.dataItem.id
            ? this.props.dataItem.id
            : "",
        zoneTypeId: this.state.zoneTypeId,
      };
      await ProductPricing.addProductPricing(newValues);

      //closing addNew Component
      this.props.toggleModal();

      //fetching data from dataBase
      this.props.dataListRender();

      // if (!this.state.isNew) {
      //   Swal.close();
      // }
      resetForm();
    } catch (error) {
      console.error(error);
      // toast(error.response.data.message);
    }
    this.setState({ loading: false });
  };

  handleChangeProduct = (e) => {
    this.setState({
      zoneTypeId: e.target.value,
    });
  };

  render() {
    return (
      <>
        <Modal
          isOpen={this.props.modalOpen}
          toggle={this.props.toggleModal}
          wrapClassName="modal-right"
          backdrop="static"
        >
          {this.state.loading ? (
            <div class="loading_apge">
              <div class="pre_loader">
                <div class="loader2">
                  <div className="loading" />
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <ModalHeader
            style={{ direction: "ltr" }}
            toggle={this.props.toggleModal}
          >
            <IntlMessages id="pages.add-new-modal-ProductPricing" />
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={this.state.initialValues}
              // validationSchema={this.ValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {(props) => (
                <Form className="form" onSubmitCapture={props.handleSubmit}>
                  <Label className="mt-4">
                    <IntlMessages id="name-moti" />
                  </Label>
                  <Field
                    name="name"
                    placeholder="نام منطقه"
                    className="form-control"
                    type="text"
                    required
                  />
                  <Label className="mt-4">
                    <IntlMessages id="areaCode" />
                  </Label>
                  <Field
                    name="areaCode"
                    placeholder="کد منطقه"
                    className="form-control"
                    type="text"
                    required
                  />
                  <Label className="mt-4">
                    <IntlMessages id="عرض جغرافیایی(lat)" />
                  </Label>
                  <Field
                    name="latitude"
                    placeholder="عرض جغرافیایی(lat) "
                    className="form-control"
                    type="number"
                    required
                  />
                  <Label className="mt-4">
                    <IntlMessages id="طول جغرافیایی(lng)" />
                  </Label>
                  <Field
                    name="longitude"
                    placeholder="طول جغرافیایی(lng)"
                    className="form-control"
                    type="number"
                    required
                  />

                  <Label className="mt-4">
                    <IntlMessages id="Product" />
                  </Label>
                  <Input onChange={this.handleChangeProduct} type="select">
                    {this.state.zoneType &&
                      this.state.zoneType.map((x) => {
                        return <option value={x.id}>{x.name}</option>;
                      })}
                  </Input>

                  <ModalFooter>
                    <Button
                      color="secondary"
                      outline
                      onClick={this.props.toggleModal}
                    >
                      <IntlMessages id="pages.cancel" />
                    </Button>
                    <Button color="primary" type="submit">
                      <IntlMessages id="pages.submit" />
                    </Button>{" "}
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
